export { consentStatus, observeConsentStatusChange } from "./Didomi"

// Didomi vendor SDK IDs used to identify vendor scripts.
// They can be found on Didomi's dashboard > "Consent Notices" > editing a consent > "Vendor & Purposes" list > "IAB/SDK ID" column
// @see https://developers.didomi.io/cmp/web-sdk/third-parties/custom-integrations/no-tag-manager#consent-to-vendors
export const THE_CONVERSATION_VENDOR_ID = "theconver-dUNGGyiP"
export const THE_CONVERSATION_PROMOS_PURPOSE = "theconver-AA8pWL4T"
